import { apiRegister } from '../utils/api'
import { array2map } from '../utils/xp.v1'

// 795	message	/message/reddot/	红点未读
export const redDotInfo = apiRegister('redDotInfo', {
  protoId: 795,
  path: '/message/reddot/',
  formatResult(R) {
    const list = R.data || []
    const map = array2map(list, 'item')
    return { ...R, list, map }
  }
}).send

// 797	message	/message/reddot/clear/	红点未读清除
export const redDotClear = apiRegister('redDotClear', {
  protoId: 797,
  path: '/message/reddot/clear/'
}).send
